<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Lastik Ölçüsü</label>
            <v-validator :errors="errors" parameter="Size" :watch="value.Size">
                <input type="text" class="form-control" placeholder="Lastik Ölçüsü" v-model="value.Size">
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <v-validator :errors="errors" parameter="Description" :watch="value.Description">
                <input type="text" class="form-control" placeholder="Açıklama" v-model="value.Description">
           </v-validator>
            
        </div>
    </div>
</template>

<script>
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
export default{
    props:{
        value:Object,
        errors:Object
    }
}
</script>